import { style, media } from 'typestyle';
import { POPUP_CARD_STYLES } from '@src/components/PopupOverlay';

export const collectFrameClass = style(
  {
    display: 'flex',
    width: 'min(960px, 92vw)',
    ...POPUP_CARD_STYLES,
  },
  media(
    { maxWidth: 900 },
    {
      flexDirection: 'column',
      width: 'min(520px, 95vw)',
    }
  )
);

export const collectFrameCompactClass = style(
  {
    width: 'min(720px, 92vw)',
  },
  media(
    { maxWidth: 900 },
    {
      width: 'min(520px, 95vw)',
    }
  )
);

export const collectFrameLoadingClass = style({ filter: 'blur(4px)', pointerEvents: 'none' });

export const collectFrameLeftClass = style({ flex: '1 1 50%', background: '#050505', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 });

export const collectFrameRightClass = style(
  {
    flex: '1 1 50%',
    padding: '24px 24px',
    minWidth: 0,
    minHeight: 0,
    background: 'transparent',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  media(
    { maxWidth: 900 },
    {
      minWidth: 'unset',
      padding: 16,
    }
  )
);

export const collectFrameTitleClass = style({ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 20, fontWeight: 600, marginBottom: 10 });

export const collectFrameRemoveClass = style({ color: '#c2c2c2', cursor: 'pointer', $nest: { '&:hover': { color: '#fff' } } });

export const inputsClass = style({ marginTop: 16 });

export const inputClass = style({ marginBottom: 12, width: '100%', background: 'rgba(255,255,255,0.04)', borderRadius: 8, padding: '10px 14px', border: '1px solid rgba(255,255,255,0.08)', color: '#fff' });

export const buttonsClass = style({
  marginTop: 20,
  display: 'flex',
  gap: 10,
  justifyContent: 'center',
  width: '100%',
  $nest: {
    'button': {
      flex: 1,
      minWidth: 0,
      maxWidth: '100%',
    },
  },
});

export const buttonBorderClass = style({ border: '1px solid #fff', color: '#fff', background: 'transparent' });

export const buttonPrimaryClass = style({ background: '#0005dc', border: 'none', color: '#fff' });

export const loaderCenteredClass = style({ position: 'absolute', zIndex: 2, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' });
